module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSIjMDAzMTljIiBkPSJNMCAwaDIxMy4zMzN2NDgwSDB6Ii8+CiAgICA8cGF0aCBmaWxsPSIjZmZkZTAwIiBkPSJNMjEzLjMzMyAwaDIxMy4zMzN2NDgwSDIxMy4zMzN6Ii8+CiAgICA8cGF0aCBmaWxsPSIjZGUyMTEwIiBkPSJNNDI2LjY2NiAwSDY0MHY0ODBINDI2LjY2NnoiLz4KICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/ro.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/ro.svg
// module chunks = 0